//piano bank
import Cpiano from './soundbank/piano1/C5.wav'
import Caugpiano  from './soundbank/piano1/C5aug.wav'
import Dpiano  from './soundbank/piano1/D5.wav'
import Daugpiano  from './soundbank/piano1/D5aug.wav'
import Epiano  from './soundbank/piano1/E5.wav'
import Fpiano  from './soundbank/piano1/F5.wav'
import Faugpiano  from './soundbank/piano1/F5aug.wav'
import Gpiano  from './soundbank/piano1/G5.wav'
import Gaugpiano  from './soundbank/piano1/G5aug.wav'
import Apiano  from './soundbank/piano1/A5.wav'
import Aaugpiano  from './soundbank/piano1/A5aug.wav'
import Bpiano  from './soundbank/piano1/B5.wav'
import C2piano  from './soundbank/piano1/C6.wav'
//guitar bank
import Cguitar from './soundbank/guitar1/C5.wav'
import Caugguitar from './soundbank/guitar1/C5aug.wav'
import Dguitar from './soundbank/guitar1/D5.wav'
import Daugguitar  from './soundbank/guitar1/D5aug.wav'
import Eguitar from './soundbank/guitar1/E5.wav'
import Fguitar from './soundbank/guitar1/F5.wav'
import Faugguitar from './soundbank/guitar1/F5aug.wav'
import Gguitar from './soundbank/guitar1/G5.wav'
import Gaugguitar  from './soundbank/guitar1/G5aug.wav'
import Aguitar from './soundbank/guitar1/A5.wav'
import Aaugguitar  from './soundbank/guitar1/A5aug.wav'
import Bguitar from './soundbank/guitar1/B5.wav'
import C2guitar  from './soundbank/guitar1/C6.wav'


 var pianoBank = [Cpiano ,Caugpiano ,Dpiano ,Daugpiano ,Epiano ,Fpiano ,Faugpiano ,Gpiano ,Gaugpiano ,Apiano ,Aaugpiano ,Bpiano ,C2piano ];
 var guitarBank = [Cguitar, Caugguitar, Dguitar, Daugguitar, Eguitar, Fguitar, Faugguitar, Gguitar, Gaugguitar, Aguitar, Aaugguitar, Bguitar, C2guitar]

 export {pianoBank, guitarBank}

